import React from 'react';
export const CFIconArrowCornerLeftUp = {
    alias: 'arrow-corner-left-up',
    defaultTitle: 'Arrow Corner Left Up',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M18 17h-5c-.55 0-1-.449-1-1V7.081l3.375 2.7a1 1 0 0 0 1.25-1.562l-5-4a1.001 1.001 0 0 0-1.25 0l-5 4a1 1 0 0 0 1.25 1.562L10 7.081V16c0 1.654 1.346 3 3 3h5a1 1 0 0 0 0-2Z' }))),
};
